import loadingAnimation from "../assets/animation/charts.json";
import brasil from "../assets/animation/brasil.json";
import line from "../assets/animation/line.json";
import bar from "../assets/animation/bar.json";
import pie from "../assets/animation/pie.json";
import charts from "../assets/animation/charts.json";
import ia from "../assets/animation/ia.json";

import { Player, Controls } from "@lottiefiles/react-lottie-player";
import React from "react";

export const LoadingAnimationType = {
  BRASIL: brasil,
  LINE: line,
  BAR: bar,
  PIE: pie,
  CHARTS: charts,
  IA: ia,


} as const;

export type LoadingAnimationType = keyof typeof LoadingAnimationType;
interface Props {
  brasil?: boolean;
  line?: boolean;
  type: LoadingAnimationType;
}
export default function SopLoadingAnimation(props: Props) {

  return (
    <div className="d-block h-100 w-100">
      <Player autoplay loop src={LoadingAnimationType[props.type]} className="height-150" />;
      {/* <Player autoplay loop src={props.brasil ? brasil : props.line ? line : loadingAnimation} className="height-150" />; */}
    </div>
  );
}
